require('../../modules/es.array.find-index');

module.exports = require('../../internals/entry-unbind')('Array', 'findIndex');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@firebase/polyfill/node_modules/core-js/es/array/find-index.js
// module id = fueK
// module chunks = 1